import React from 'react'

import { useLoadScript } from '@react-google-maps/api'

/**
 * High Order Component that provides Google Maps to Components
 *
 * @returns {function(*): *}
 */
const withGoogleMaps = Component => props => {

  const { isLoaded } = useLoadScript({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY
  })

  return <Component isGoogleMapsLoaded={ isLoaded } { ...props } />
}

export default withGoogleMaps
